export const INVITE_USER_BY_MAIL = "invite-user-by-mail";
export const FETCH_INVITES = "fetch-invites";
export const SEARCH_BY_MAIL = "search-by-mail";
export const REVOKE_INVITE = "revoke-invite";
